export default {
  scenes: {
    rehearsalDinner: {
      beats: {
        unspokenLonging: {
          events: [
            {
              type: 'showLocation',
              locationId: 'gardenTerrace'
            },
            {
              type: 'showCharacter',
              characterId: 'daniel',
              variation: 'thinking',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'daniel',
              variation: 'thinking',
              text: 'I was hoping you\'d come out here. Dance with me? Just one dance.'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'We shouldn\'t...'
            },
            {
              type: 'showDialog',
              speaker: 'daniel',
              variation: 'neutral',
              text: 'Nobody\'s watching. Just one moment of honesty before tomorrow.'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'One dance. Then we go back to reality.',
              choices: [
                {
                  text: 'Accept His Invitation to Dance',
                  next: {
                    scene: 'rehearsalDinner',
                    beat: 'oneLastDance'
                  }
                },
                {
                  text: 'Keep Professional Distance',
                  next: {
                    scene: 'rehearsalDinner',
                    beat: 'theHardTruth'
                  }
                }
              ]
            }
          ]
        },
        oneLastDance: {
          events: [
            {
              type: 'showEffect',
              effect: 'vignette',
              intensity: 0.3
            },
            {
              type: 'showDialog',
              speaker: 'daniel',
              variation: 'neutral',
              text: 'In another life...'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'sad',
              text: 'Don\'t. Please don\'t say it.'
            },
            {
              type: 'showDialog',
              speaker: 'daniel',
              variation: 'neutral',
              text: 'Tell me you feel nothing, and I\'ll walk away right now.'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'sad',
              text: 'I can\'t lie to you. But I can\'t destroy Emily\'s happiness either.'
            },
            {
              type: 'hideEffect',
              effect: 'vignette'
            }
          ],
          next: {
            scene: 'lateNightConfession',
            beat: 'midnightTruths'
          }
        },
        theHardTruth: {
          events: [
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'You should be inside with Emily. It\'s your rehearsal dinner.'
            },
            {
              type: 'showDialog',
              speaker: 'daniel',
              variation: 'angry',
              text: 'Always the voice of reason, aren\'t you?'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'Someone has to be. This isn\'t a fairy tale, Daniel. Tomorrow you\'re marrying Emily.'
            },
            {
              type: 'showDialog',
              speaker: 'daniel',
              variation: 'sad',
              text: 'Is that what you really want?'
            }
          ],
          next: {
            scene: 'lateNightConfession',
            beat: 'midnightTruths'
          }
        }
      }
    },
    lateNightConfession: {
      beats: {
        midnightTruths: {
          events: [
            {
              type: 'showLocation',
              locationId: 'gardenTerrace'
            },
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'neutral',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'daniel',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'sad',
              text: 'If we had met first... if things were different...',
              choices: [
                {
                  text: 'Admit Their Timing Was Wrong',
                  next: {
                    scene: 'lateNightConfession',
                    beat: 'theAlmostChoice'
                  }
                },
                {
                  text: 'End It Definitively',
                  next: {
                    scene: 'lateNightConfession',
                    beat: 'theFinalWall'
                  }
                }
              ]
            }
          ]
        },
        theAlmostChoice: {
          events: [
            {
              type: 'showDialog',
              speaker: 'daniel',
              variation: 'sad',
              text: 'We could walk away right now. Just you and me.'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'sad',
              text: 'And live with ourselves? With what we did to Emily? We can\'t.'
            },
            {
              type: 'showDialog',
              speaker: 'daniel',
              variation: 'sad',
              text: 'Always doing the right thing. Even when it breaks your heart.'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'sad',
              text: 'Go back inside, Daniel. Be with Emily. Be happy.'
            },
            {
              type: 'showDialog',
              speaker: 'daniel',
              variation: 'sad',
              text: 'I\'ll always wonder...'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'sad',
              text: 'So will I. Goodbye, Daniel.'
            }
          ],
          goToChapter: {
            chapter: 'chapter5'
          }
        },
        theFinalWall: {
          events: [
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'This has to stop. Tomorrow you\'re getting married. We need to accept that.'
            },
            {
              type: 'showDialog',
              speaker: 'daniel',
              variation: 'angry',
              text: 'Just like that? Pretend this meant nothing?'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'It has to mean nothing. For everyone\'s sake.'
            },
            {
              type: 'showDialog',
              speaker: 'daniel',
              variation: 'angry',
              text: 'I\'ll remember that when I say \'I do.\''
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'Everything is set for tomorrow. I\'ll see you at the ceremony.'
            },
            {
              type: 'showDialog',
              speaker: 'daniel',
              variation: 'angry',
              text: 'Perfect. The consummate professional until the end.'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'sad',
              text: 'It\'s better this way. It has to be.'
            }
          ],
          goToChapter: {
            chapter: 'chapter5'
          }
        }
      }
    }
  }
}
